<template>
    <div
        :class="!dialog ? 'container d-flex align-items-center justify-content-center reset-pass' : ''"
    >
        <notifications v-if="!dialog"></notifications>
        <div :class="!dialog ? 'col-md-8 col-xs-12' : 'col-12'">
            <card
                type="secondary"
                shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0"
                style="margin-bottom: 0"
            >
                <template v-if="true">
                    <div class="text-muted text-center">{{ $t('login.password.reset') }}</div>
                </template>
                <template v-if="true">
                    <form role="form" class="mt-4">
                        <base-input
                            v-model="password"
                            v-validate="'required'"
                            :name="$t('login.password.title')"
                            type="password"
                            :placeholder="$t('login.password.title')"
                            prepend-icon="ni ni-lock-circle-open"
                            :error="errors.first($t('login.password.title'))"
                        ></base-input>
                        <base-input
                            v-model="passwordConfirm"
                            v-validate="{ is: password, required: true }"
                            :name="$t('login.password.confirm')"
                            type="password"
                            :placeholder="$t('login.password.confirm')"
                            prepend-icon="ni ni-lock-circle-open"
                            :error="errors.first($t('login.password.confirm'))"
                        ></base-input>
                        <div class="text-center">
                            <base-button
                                @click.stop="submit"
                                :loading="loading"
                                type="success"
                                class="my-4"
                            >{{ $t('login.password.change.title') }}</base-button>
                        </div>
                    </form>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import Card from "../../argon/components/Cards/Card";
import BaseInput from "../../argon/components/Inputs/BaseInput";
import BaseButton from "../../argon/components/BaseButton";

export default {
    name: "ResetPassword",
    props: {
        token: {
            type: String,
            required: false
        },
        dialog: {
            type: Boolean,
            required: false,
            default: false
        },
        user: {
            type: Object,
            required: false
        },
        color: {
            type: Object,
            required: true
        }
    },
    components: {
        Card,
        BaseInput,
        BaseButton
    },
    data() {
        return {
            password: "",
            passwordConfirm: "",
            loading: false
        };
    },
    methods: {
        submit() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true;

                    if (!this.dialog) {
                        window.axios
                            .post("/password/reset", {
                                password: this.password,
                                token: this.token
                            })
                            .then(res => {
                                this.$notify({
                                    type: "success",
                                    message: res.data.message
                                });
                                localStorage.setItem(
                                    "nochalks_token",
                                    res.data.token
                                );

                                setTimeout(() => {
                                    location.href = "/app/dashboard";
                                }, 1500);
                            })
                            .catch(err => {
                                this.$notify({
                                    type: "danger",
                                    message: this.$t(
                                        "login.password.change.error"
                                    )
                                });
                                this.loading = false;
                            });
                    } else {
                        window.axios
                            .patch("/api/app/profile/password", {
                                id: this.user.id,
                                password: this.password
                            })
                            .then(res => {
                                this.$notify({
                                    type: "success",
                                    message: res.data.message
                                });

                                if (res.data.redirect) {
                                    return setTimeout(
                                        () =>
                                            (location.href = res.data.redirect),
                                        1500
                                    );
                                }

                                location.reload();
                            })
                            .catch(err => console.log(err));
                    }
                }
            });
        }
    }
};
</script>

<style scoped>
.reset-pass {
    flex: 1;
}
</style>
